import React from 'react'
import { Grid, TextField, Typography } from '@material-ui/core'
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete'
import { SelecionarData } from 'components'
import { cutMaxLength } from 'utils/helpers'
import useStyles from './styles'

const maxLength250 = (newValue) => cutMaxLength(newValue, 250)
const filterOptions = createFilterOptions({
  matchFrom: 'any',
  limit: 100,
})

const extraFilter = (options, params) => {
  const filtered = filterOptions(options, params);
  const q = params.inputValue?.toLowerCase()?.replace(/\.|-/g, '');
  const extra = options.filter(
    (o) => o.matricula?.replace(/\.|-/g, '').toLowerCase().includes(q) && !filtered.includes(o)
  );
  return [...filtered, ...extra];
}


export const Responsavel = (props) => {
  const {
    usuarios,
    label,
    nome,
    inputName,
    dateName,
    values,
    touched,
    errors,
    onChangeUser,
    onChangeInput,
    onChangeDate,
    onBlur,
    formVestigio,
    extrafilterOptions = false,
  } = props
  const classes = useStyles()

  // Fallback seguro para suportar o estado do formulário legado ou novo
  const formValues = values || formVestigio?.formState?.values || {}
  const formTouched = touched || formVestigio?.formState?.touched || {}
  const formErrors = errors || formVestigio?.formState?.errors || {}

  const hasError = (fieldName) => {
    if (errors) {
      return touched?.[fieldName] && !!errors[fieldName]
    }
    return formVestigio?.hasError?.(fieldName)
  }

  const getHelperText = (fieldName) => {
    if (errors) {
      return touched?.[fieldName] && errors[fieldName] ? errors[fieldName] : null
    }
    if (formVestigio?.hasError?.(fieldName)) {
      const errs = formVestigio.formState.errors[fieldName]
      return Array.isArray(errs) ? errs[0] : errs
    }
    return null
  }

  const handleUserChange = (event, newValue) => {
    if (onChangeUser) {
      onChangeUser(nome, newValue)
    } else if (formVestigio) {
      formVestigio.handleChangeNewValueByNameProperty(event, newValue, nome)
    }
  }

  const handleInputChange = (e) => {
    if (onChangeInput) {
      onChangeInput(e, maxLength250)
    } else if (formVestigio) {
      formVestigio.handleChange(e)
    }
  }

  const handleDateChange = (data) => {
    if (onChangeDate) {
      onChangeDate(dateName, data)
    } else if (props.setDate) {
      props.setDate(data)
    }
  }

  const handleBlurField = () => {
    if (onBlur) {
      onBlur(nome)
    }
  }

  const getUsuarioLabel = (option) => {
    if (!option) return ''
    const nomeUsu = option.nome?.toUpperCase() || ''
    const cargo = option.cargo?.nome ? ` - ${option.cargo.nome.toUpperCase()}` : ''
    return `${nomeUsu}${cargo}`
  }

  const isOutroSelected = formValues[nome]?.nome?.toUpperCase() === 'OUTRO'

  return (
    <Grid container spacing={2} style={{ marginBottom: '24px' }}>
      {/* Autocomplete de Usuários */}
      <Grid item xs={12} sm={8} md={9}>
        <Autocomplete
          value={formValues[nome] || null}
          name={nome}
          filterOptions={extrafilterOptions ? extraFilter : filterOptions}
          noOptionsText="Sem informações"
          options={usuarios || []}
          onChange={handleUserChange}
          onBlur={handleBlurField}
          getOptionLabel={getUsuarioLabel}
          getOptionSelected={(option, value) => option.id === value.id}
          renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                placeholder="Selecionar..."
                label={label}
                required
                InputLabelProps={{
                  shrink: true,
                }}
                error={!!hasError(nome)}
                helperText={getHelperText(nome)}
              />
          )}
          className={classes.tipoVestigio}
        />
      </Grid>

      {/* Seleção de Data */}
      <Grid item xs={12} sm={4} md={3}>
        <SelecionarData 
          dataBD={formValues[dateName]} 
          callback={handleDateChange} 
          shrink 
          label="Data" 
          maxDate={Date.now()} 
          xs={12}
          sm={12}
          md={12}
        />
      </Grid>

      {/* Exibição condicional do campo de Outro Usuário */}
      {isOutroSelected && (
        <Grid item xs={12} style={{ marginTop: '4px' }}>
          <TextField
            value={formValues[inputName] || ''}
            variant="outlined"
            fullWidth
            label={`OUTRO USUÁRIO ${label.toUpperCase()}`}
            InputLabelProps={{
              shrink: true,
            }}
            onChange={handleInputChange}
            name={inputName}
          />
          <Typography variant="caption" color="textSecondary" style={{ marginTop: '4px', display: 'block' }}>
            Caracteres restantes: {250 - (formValues[inputName]?.length || 0)}
          </Typography>
        </Grid>
      )}
    </Grid>
  )
}
